import "./style.scss";

export default function SectionDivider({ label, color, sub }) {
  return (
    <div
      className="compSectionDivider"
      style={{ "--divider-color": color }}
    >
      <div className="compSectionDivider__accent" />
      <div>
        <div className="compSectionDivider__label">
          {label}
        </div>
        {sub && <div className="compSectionDivider__sub">{sub}</div>}
      </div>
    </div>
  );
}
